var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuperapply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F4F4F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9805 15.0156C22.9805 15.0156 23.4805 15.5156 23.9805 16.5156C23.9805 16.5156 25.5687 14.0156 26.9805 13.5156",
    stroke: "#2E2D7E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9949 10.0214C15.4964 9.91562 13.5661 10.2034 13.5661 10.2034C12.3473 10.2906 10.0115 10.9739 10.0115 14.9646C10.0115 18.9214 9.98564 23.7994 10.0115 25.744C10.0115 26.9321 10.7471 29.7034 13.2933 29.8519C16.3881 30.0325 21.9627 30.0709 24.5204 29.8519C25.2051 29.8133 27.4846 29.2758 27.7731 26.7957C28.072 24.2264 28.0125 22.4408 28.0125 22.0158",
    stroke: "#2E2D7E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9998 15.0156C29.9998 17.777 27.7591 20.0157 24.995 20.0157C22.2309 20.0157 19.9902 17.777 19.9902 15.0156C19.9902 12.2542 22.2309 10.0156 24.995 10.0156C27.7591 10.0156 29.9998 12.2542 29.9998 15.0156Z",
    stroke: "#2E2D7E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9805 21.0156H18.9804",
    stroke: "#2E2D7E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9805 25.0156H22.9804",
    stroke: "#2E2D7E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuperapply);
export default __webpack_public_path__ + "static/media/superapply.183cab4ce5b200df3561cc8f507a0377.svg";
export { ForwardRef as ReactComponent };